export const DOCUMENTS = 'documents'
export const BILLING = 'billing'
export const FRONT_API = 'frontApi'
export const PRO_API = 'pro-api'
export const SURVEY = 'survey'
export const SYLIUS = 'sylius'
export const ENGINE = 'engine'
